import React, { useState, useEffect, useRef } from 'react';
import { ReactComponent as DOWN } from "../../../assets/icons/filter-down.svg";
import { ReactComponent as UP } from "../../../assets/icons/filter-up.svg";
import "./TranslatorDropdown.css";

function TeamDropdown({ order, clients, customClass, icon, onChange, member = false }) {
  const [selectedTranslator, setSelectedTranslator] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const dropdownRef = useRef(null);

  console.log("selectedTranslator",selectedTranslator)

  useEffect(() => {
    if(order){
      setSelectedTranslator(order?.translator?.id || "");
    }
  }, [order]);

  const handleSelect = async (selectedValue) => {
    if (!selectedValue) return;
    setSelectedTranslator(selectedValue);
    setIsOpen(false);
    setSearchTerm("");
    
    if (onChange) {
      onChange(selectedValue);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

const filteredClients = (clients || []).filter(
    (client) =>
      client.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      client.email?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  if (clients.length === 0) {
    return (
      <div className={`custom-dropdown-container w-full single-client`}>
        <div className={`custom-dropdown-header single-client ${customClass || ""}`}>
          No Data to  Add
        </div>
      </div>
    );
  }
  if (clients.length === 1) {
    onChange(clients[0]);
    return (
      <div className={`custom-dropdown-container w-full single-client`}>
        <div className={`custom-dropdown-header single-client ${customClass || ""}`}>
        <div className="selected-client">
          <span className="selected-client-name">{clients[0].name}</span>
          <span className="selected-client-email">
            {clients[0]?.email || ""}
          </span>
        </div>
        </div>
      </div>
    );
  }

  return (
    <div className={`custom-dropdown-container w-full`} ref={dropdownRef}>
      <div
        className={`custom-dropdown-header ${customClass || ""} ${isOpen && 'active'}`}
        onClick={() => {setIsOpen(!isOpen)}}
      >
        {selectedTranslator ?
                <div className="selected-client">
                  <span className="selected-client-name">{selectedTranslator.name}</span>
                  <span className="selected-client-email">
                    {selectedTranslator.email}
                  </span>
                </div>
          : member ? "Choose Member" : "Choose Team"}
        {icon === 'true' && (
          <div>{isOpen ? <UP className="dropdown-icon" /> : <DOWN className="dropdown-icon" />}</div>
        )}
      </div>
      {isOpen && (
        <div className="custom-dropdown-options">
          <input
            type="text"
            className="languageSearchFormsInput"
            placeholder="Search..."
            value={searchTerm}
            autoFocus
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <div className='custom-dropdown-options-wrap'>
            {filteredClients.map((t) => (
              <div
                key={t.id}
                className="custom-dropdown-option-select"
                onClick={() => handleSelect(t)}
              ><div className="dropdown-item-name">{t.name}</div>
                  <div className="dropdown-item-email">{t.email}</div>
              </div>
            ))}
        </div>
        </div>
      )}
    </div>
  );
}

export default TeamDropdown;
